
























import {Component, Vue} from 'vue-property-decorator'
import {Getter} from 'vuex-class'
import {InventoryItem, Room} from '@/store/types'
import ListItem from '@/components/common/ListItem.vue'
import FontAwesome from '@/classes/FontAwesome'

@Component({
  components: {
    ListItem,
  },
})
export default class SummaryInfoItems extends Vue {
  @Getter('inventory') public inventory!: InventoryItem[]
  @Getter('totalVolume') public totalVolume!: number
  @Getter('rooms') public rooms!: Room[]

  public FontAwesome = FontAwesome

  public roomItems(room: Room): InventoryItem[] {
    return this.inventory.filter((i) => i.lead_room_id === room.id)
  }
}
